import React from 'react';
import Layout from './src/layout';

const wrapPage = ({ element, props }) => <Layout {...props}>{element}</Layout>;

export default wrapPage;
